import * as React from 'react';
import { Properties } from '../';
import { IControlBlock, DOMHelper, IOutputValue, ComponentHelper, IOutputReference, PropertyHelper, IProperty } from '../../helpers';
import { CONTROL_BLOCK_LOOPING_PROPERTIES } from '../../constants';
import {
    DialogFooter, IDropdownOption,
	Button, ButtonType, 
	MessageBarType, MessageBar,
	Label
} from 'office-ui-fabric-react';

interface IProps {
	controlBlock: IControlBlock;
	outputOptions:IDropdownOption[];
	allOutputReferences: IOutputReference[];
	closeDialog: (save?: boolean) => void;
	updateProperty: (key: string, value: any) => void;
}

export class ControlBlockConfig extends React.Component<IProps, any> {

	constructor(props: any) {
        super(props);
    }

	public componentDidMount() {
        DOMHelper.setDropdownPropertyTabIndex();
        DOMHelper.focusOnFirstModalTabbableControl();
	}

	public render() {

		let { controlBlock, closeDialog, updateProperty, outputOptions, allOutputReferences } = this.props;

		let repeatableControlBlockEnabled = true;

		let relevantProperties: IProperty[] = controlBlock.Properties.filter(p => CONTROL_BLOCK_LOOPING_PROPERTIES.indexOf(p.Name) >= 0);

		return (
			allOutputReferences && allOutputReferences.length ?
			<div className='control-block-config-container'>
				<MessageBar className='error-display' messageBarType={ MessageBarType.error } >
					<Label>This Control Block cannot be configured for looping because of the following issues.</Label>
					{allOutputReferences.map((r, i) => {
						return <div key={'error-container-' + i}>
							{'The output "' + r.referencedOutputName + '" of the control "' + r.referencedControlName + '" is referenced by:'}							
							<ul>
							{r.referringMessages.map((m, j) => {
								return <li key={'error-' + i + '-' + j}>
									{m}
								</li>;
							})}
							</ul>
						</div>;
					})}
				</MessageBar>
			</div>
			: <div className='control-block-config-container'>

				<div className="control-block-properties">
					<Properties primaryOnly={ false } change={ updateProperty } componentId={ controlBlock.ComponentId } 
						properties={ relevantProperties } outputOptions={ outputOptions } />
				</div>

                <DialogFooter>
                    <Button tabIndex={1001} buttonType={ ButtonType.normal } onClick={ () => closeDialog(false) }>Cancel</Button>
                    <Button tabIndex={1002} onBlur={ () => { DOMHelper.focusOnFirstModalTabbableControl(); } }
						buttonType={ ButtonType.primary } onClick={ () => closeDialog(true) }>Save</Button>
                </DialogFooter>

			</div>
		);

	}

}


// WEBPACK FOOTER //
// ./source/ts/components/controls/control-block.tsx